import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PuzzleWinTypesEnum } from '../../puzzle-framework-module/puzzle-win-types.enum';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import {
  ModalController,
  IonButton,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspaceSharp, sendSharp } from 'ionicons/icons';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleSolutionWordDialogService } from './puzzle-solution-word-dialog.service';
import { PuzzleFrameworkConfigModel } from '../../store/puzzle-framework-config.model';
import { Store } from '@ngxs/store';

import { PuzzleSolutionWordAnimationComponent } from 'projects/tools/src/lib/shared-module/puzzle-solution-word-animation/puzzle-solution-word-animation.component';

@Component({
  selector: 'lib-app-puzzle-solution-word-dialog',
  templateUrl: './puzzle-solution-word-dialog.component.html',
  styleUrls: ['./puzzle-solution-word-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonButton,
    IonContent,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonList,
    IonRow,
    IonText,
    IonTitle,
    IonToolbar,
    PuzzleSolutionWordAnimationComponent,
    TranslateModule,
  ],
})
export class PuzzleSolutionWordDialogComponent {
  @Input() sweepstake: boolean;
  @Input() winType: PuzzleWinTypesEnum;
  @Input() isSayingDialog: boolean;

  // private puzzleGameSubscription: Subscription;
  public solutionWord: string;
  public solutionOriginal: string;
  private puzzleFrameworkConfig: PuzzleFrameworkConfigModel;
  public saying: string;
  public sayingOriginal: string;

  constructor(
    private ionicModal: ModalController,
    private solutionDialogService: PuzzleSolutionWordDialogService,
    private store: Store,
    private framework: PuzzleFrameworkService
  ) {
    addIcons({
      sendSharp,
      backspaceSharp,
    });
    this.solutionDialogService.solutionWords$.subscribe((solutionWords) => {
      if (!solutionWords) {
        return;
      }
      this.solutionWord = solutionWords.solutionWord;
      this.solutionOriginal = solutionWords.solutionOriginal;
    });

    this.solutionDialogService.sayings$.subscribe((data) => {
      if (!data) {
        return;
      }
      this.saying = data.saying;
      this.sayingOriginal = data.sayingOriginal;
    });

    this.solutionDialogService.registerSolutionDialog();

    this.store
      .select((state) => state.puzzleFrameworkConfig)
      .subscribe((puzzleFrameworkConfig) => {
        this.puzzleFrameworkConfig = puzzleFrameworkConfig;
      });
  }

  async closeDialog(userWantsToApply: boolean) {
    // If the user wants to apply (take part in sweepstake) we don't close the dialog if we open in same window.
    if (userWantsToApply && !this.puzzleFrameworkConfig.solutionWordConfig.sweepstake.targetBlank) {
      this.framework.sendSolutionWordData(this.solutionWord);
    } else {
      await this.ionicModal.dismiss(userWantsToApply);
    }
  }
}
